export const SUGGESTED_PRODUCTS_DATA_QUERY_KEY = 'suggested-products-data';
